// D20 / DR9 (birim varyantı) — yazımda 409 KPI_UNIT_CHANGED ortak yardımcıları (danışman + portal
// store). Sunucu yazmaz ve güncel etkin birimi `details.current` ile döner; FE gösterge birimini
// yerelde günceller (yeniden yükleme yok) ve portalda hücreye amber satır durumu yazar.

import { formatKpiNumber, type KpiResolvedGrid } from "@mahir/shared";

/** Portal hücresi: "Bu göstergenin birimi {from} → {to} … Girdiğiniz {typed} kaydedilmedi" */
export interface PortalUnitChanged {
  from: string | null;
  to: string | null;
  /** eski birimiyle yazılan değer ("1.200 TL") — metinde kalır */
  typed: string;
  /** editör taslağı (sayı TR biçiminde; otomatik yeniden gönderim yok) */
  draft: string;
}

/** 409 gövdesinin `details.current`'ı (string | null); başka biçim → undefined. */
export function unitChangedCurrent(details: unknown): string | null | undefined {
  if (!details || typeof details !== "object" || !("current" in details)) return undefined;
  const c = (details as { current?: unknown }).current;
  return typeof c === "string" || c === null ? c : undefined;
}

/** Göstergenin birimini yerelde günceller (diğer alanlar ve hücreler aynen). */
export function patchIndicatorUnit(
  grid: KpiResolvedGrid,
  metricId: string,
  unit: string | null,
): KpiResolvedGrid {
  return {
    ...grid,
    indicators: grid.indicators.map((ind) => (ind.metricId === metricId ? { ...ind, unit } : ind)),
  };
}

/** Yazılan girdiden amber satır durumu (sayı TR biçiminde + eski birim). */
export function buildPortalUnitChanged(
  args: { numericValue?: number | undefined; textValue?: string | undefined },
  from: string | null,
  to: string | null,
): PortalUnitChanged {
  const draft =
    typeof args.numericValue === "number"
      ? formatKpiNumber(args.numericValue)
      : (args.textValue ?? "");
  const typed = draft && from && typeof args.numericValue === "number" ? `${draft} ${from}` : draft;
  return { from, to, typed, draft };
}
